export default [
    {
        path: '/activities',
        name: 'Activities',
        component: () => import ('./Activities'),
    }
];